module.exports = __webpack_public_path__ + "resources/react-app/img/Tipigo-build-banner.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Tipigo-build-banner.jpg
// module id = 1148
// module chunks = 0